import Image from 'next/image';
import Link from 'next/link';

const FooterSmall = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-small-wrapper">
      <div className="container-default w-container">
        <div className="footer-small">
          <Link href="/" className="footer-logo-wrapper small mg-bottom-0 w-inline-block">
            <Image
              src="/images/logo-light.svg"
              alt="Logo - Brandymail.com"
              className="footer-logo"
              height={50}
              width={150}
            />
          </Link>
          <p className="color-neutral-700 mg-bottom-0 footer-small-copyright">
            Copyright &copy; {currentYear} Brandymail.com. All rights reserved.
          </p>
        </div>
      </div>

      <style jsx>{`
        @media (max-width: 768px) {
          .footer-small-wrapper {
            padding-bottom: calc(
              80px + env(safe-area-inset-bottom, 0)
            ); /* Space for bottom tab bar */
          }

          .footer-small-copyright {
            font-size: 11px !important; /* Smaller text on mobile */
            line-height: 1.4 !important;
            text-align: center;
            padding: 0 16px;
          }

          .footer-small {
            gap: 12px; /* Tighter spacing on mobile */
          }

          :global(.footer-logo-wrapper.small img) {
            height: 40px !important; /* Smaller logo on mobile */
            width: auto !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default FooterSmall;
